export const getEnvByDomain = () => {
  const domain = window.location.hostname;
  if (domain.endsWith("-dev.playpadel.io")) {
    return "development";
  }
  if (domain.endsWith("playpadel.io")) {
    return "production";
  }
  return "local";
};
